var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDefaultAvatarV = function SvgDefaultAvatarV(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3 55.4c1.4 0 2-1 2.7-2.6 1.4-3.2 4.9-12.4 7.8-19.9 1.3-3.2 2-4.5 2.9-5 2-.2 2.7-.6 2.7-1.3 0-1-2-1.6-5.7-1.6s-6 .5-6 1.6c0 .8.9 1.2 3.5 1.3.5.8.3 2.6-.8 5.7-1.3 4.1-4 11.1-6.1 16.2-2.3-4.7-4.4-10-6.2-15.2-1.3-3.7-1.8-5.9-1.4-6.5 2.4-.2 3.4-.5 3.4-1.3 0-1-1.9-1.7-6.5-1.7s-6.8.6-6.8 1.8c0 .8.8 1.1 2.7 1.3.5.2 1 .8 2.3 4 2.4 6.2 6.4 16.2 8.7 20.9.7 1.5 1.3 2.3 2.8 2.3z"
  })));
};
export default SvgDefaultAvatarV;